import { SET_FLAGS } from './actions';

export const namespace = 'featureFlags';

export const featureFlagReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_FLAGS:
      return Object.assign({}, state, action.data);

    default:
      return state;
  }
};
